import type { TemplateSection } from 'inspection-types';
import type { AddSectionFromTemplateParams } from 'react-hooks';

export type UnhideSectionInput = {
  channelId: string;
  templateId: string;
  section: TemplateSection;
};

export function buildUnhideSectionParams({
  channelId,
  templateId,
  section,
}: UnhideSectionInput): AddSectionFromTemplateParams {
  const { removed: _removed, ...storedSection } = section;

  return { channelId, templateId, section: storedSection };
}
